module.exports = __webpack_public_path__ + "static/media/corona.a30dc93b.gif";